import { IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import { clearStoreAndLogout } from "../../helpers/authHelper";

const Header = ({
  isBikes24 = false,
  hideUser = false,
}: {
  isBikes24?: boolean;
  hideUser?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigation = useNavigate();
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    clearStoreAndLogout();
    navigation("/");
    handleClose();
  };
  return (
    <div className="fixed bg-white w-full h-16 flex justify-between px-3 shadow-md items-center z-[1000]">
      <div className="flex items-center gap-2">
        <img
          src={"/mosaic_logo.svg"}
          alt="logo"
          className="p-2 h-[80%] cursor-pointer"
          onClick={() => {
            navigation("/dashboard");
          }}
        />
      </div>

   
      {!hideUser && (
        <IconButton
          size="large"
          edge="end"
          color="inherit"
          aria-label="user account"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <AccountCircleIcon fontSize={"large"} className="text-gray-400" />
        </IconButton>
      )}
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        className="mt-4"
        keepMounted
        // transformOrigin={{
        //   vertical: "center",
        //   horizontal: "right",
        // }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>

      {/* <Select>
        <ListItemIcon>
          <InboxIcon />
        </ListItemIcon>
        <ListItemText primary="Inbox" />
        <MenuItem value=""></MenuItem>
        <MenuItem value={10}>Ten</MenuItem>
        <MenuItem value={20}>Twenty</MenuItem>
        <MenuItem value={30}>Thirty</MenuItem>
      </Select> */}
    </div>
  );
};

export default Header;
